import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline row q-col-gutter-sm" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timeline_section = _resolveComponent("timeline-section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_timeline_section, {
        "client-id": _ctx.client.id,
        "date-of-loss": _ctx.client.dateOfLoss
      }, null, 8, ["client-id", "date-of-loss"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_timeline_section, {
        "client-id": _ctx.client.id,
        "date-of-loss": _ctx.client.dateOfLoss,
        "post-date-of-loss": ""
      }, null, 8, ["client-id", "date-of-loss"])
    ])
  ]))
}